enum SettingType {
	Integer = "Integer"
}

export default SettingType;